var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CBox',[_c('CHeading',{attrs:{"color":"fontMain","size":"2xl"}},[_vm._v(_vm._s(_vm.label))]),_c('CDivider',{attrs:{"borderColor":"dividerColor"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }